import { render, staticRenderFns } from "./ContactInformationPopUp.vue?vue&type=template&id=28dbdb18&scoped=true&"
import script from "./ContactInformationPopUp.vue?vue&type=script&lang=js&"
export * from "./ContactInformationPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbdb18",
  null
  
)

export default component.exports